import React from "react";
import { Link } from "react-router-dom";

const wordmarkLinen = "/assets/logos/crowther-wordmark-white.webp";
const wordmarkSeafoam = "/assets/logos/crowther-wordmark-seafoam.webp"; // admin light surface
const wordmarkForest = "/logos/wordmark-black-fit.png";                 // marketing/audit Linen surface

export function Header({ variant = "dark", tagline }) {
  const isLight = variant === "light";
  const isForest = variant === "forest"; // Linen page, forest wordmark, same look as marketing
  const defaultTag = isLight ? "Deal Board" : "AI Strategy Audit";
  const src = isForest ? wordmarkForest : isLight ? wordmarkSeafoam : wordmarkLinen;
  return (
    <header
      className={`cw-header ${isLight ? "light" : ""} ${isForest ? "forest" : ""}`}
      data-testid="app-header"
    >
      <div className="cw-header-inner">
        <Link
          to={isLight ? "/admin/deal-board" : "/"}
          className="brand"
          aria-label="Crowther"
          data-testid="brand-link"
        >
          <img src={src} alt="Crowther" className="brand-wordmark" />
        </Link>
        <div className="tagline" data-testid="header-tagline">
          {tagline || defaultTag}
        </div>
      </div>
    </header>
  );
}
